import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  saveClient,
  setEditMode,
} from '../../actions/advisor';
import s from './EditGoalsForm.css';

class EditGoalsForm extends PureComponent {

  constructor(props) {
    super(props);
    const newClient = Object.assign({}, this.props.client);
    this.state = {
      client: newClient,
    };
  }

  // update the value to state for form text fields
  editClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
     } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // save client with current saved state values
  saveClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    this.props.saveClient(client).then(() => {
      this.props.setEditMode('');
    });   
  }

  clearEditMode = (event) => {
    event.preventDefault();
    this.props.setEditMode('');
  }

  render() {
    const {
      client,
    } = this.state;
    return (
      <div className={s.content}>
        <form>
          <div className={'form-group'}>
              <label htmlFor="birthYear" className={s.formLabel}>Birth Year</label>
              <input
                name="birthYear"
                value={client.birthYear}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'}
                placeholder=""
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="retireAge" className={s.formLabel}>Retirement Age</label>
              <input
                name="retireAge"
                value={client.retireAge}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'}
                placeholder=""
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="currentSavings" className={s.formLabel}>Current Savings</label>
              <input
                name="currentSavings"
                value={client.currentSavings}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'}
                placeholder=""
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="monthlySavings" className={s.formLabel}>Pre-Retirement Monthly Contribution</label>
              <input
                name="monthlySavings"
                value={client.monthlySavings}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'}
                placeholder=""
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="retireMonthlyIncome" className={s.formLabel}>Prefered Retirement Yearly Income</label>
              <input
                name="retireMonthlyIncome"
                value={client.retireMonthlyIncome}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'}
                placeholder=""
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="shortTermYears" className={s.formLabel}>Mid Term Horizon (years)</label>
              <select
                name="shortTermYears"
                value={client.shortTermYears}
                onChange={this.editClientFormChange}
                className={'form-control'}
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
          </div>
          <div className={'form-group'}>
              <label htmlFor="laScore" className={s.formLabel}>Loss Aversion Score (override)</label>
              <select
                name="laScore"
                value={client.laScore}
                onChange={this.editClientFormChange}
                className={'form-control'}
              >
                <option value="0">None</option>
                <option>1</option>
                <option>1.25</option>
                <option>1.5</option>
                <option>1.75</option>
                <option>2</option>
                <option>2.25</option>
                <option>2.5</option>
                <option>2.75</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
              </select>
          </div>
          <div className={'row'} style={{marginTop:'30px'}}>
            <div className='col-md-6'>
              <button
                onClick={this.saveClient}
                className={s.saveButton}
              >SAVE</button>
            </div>
            <div className='col-md-6'>
              <button
                onClick={this.clearEditMode}
                className={s.cancelButton}
              >CANCEL</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveClient,
  setEditMode,
})(EditGoalsForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditGoalsForm.js